import React, { Component } from 'react';
import axios from "axios";

import ProductSlider from './utils/ProductSlider';
import MainSlider from './utils/MainSlider';
import HomeStaticBanner1 from './utils/HomeStaticBanner1';
import HomeStaticBanner2 from './utils/HomeStaticBanner2';
import HomeStaticBanner3 from './utils/HomeStaticBanner3';
import HomeStaticBanner4 from './utils/HomeStaticBanner4';
import HomeStaticBanner8 from './utils/HomeStaticBanner8';
import HomeStaticBanner8sub from './utils/HomeStaticBanner8sub';
import Testimonial from './utils/Testimonial';

import Loader from './utils/Loader';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mainslider:[],
            products:[],
            home:[],
            serviceCheck:false,
        }   
    }

    async componentDidMount() {
        window.scrollTo(0, 0);

        try {
            const response = await axios.get('https://shop.mybadge.co.in/api/apiv1/mainBanner');
             let resVal=response.data;
              if(resVal.status==='success'){
                  this.setState({mainslider:resVal.data});
              }
          } catch (error) {
            console.error(error);
          }

        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
        const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/home',params);
            let resVal=response.data;
            // console.log(resVal);
            if(resVal.status==='success'){
                this.setState({home:resVal.data});
                this.setState({serviceCheck:true});
            }
        } catch (error) {
            this.setState({serviceCheck:true});
            console.error(error);
        }

        const script = document.createElement("script");
        script.async = true;
        script.src = "/assets/js/main.js";
        document.body.appendChild(script); 

    }

    render() {

        // if(this.state.serviceCheck===false)
        // return (<Loader/>);

        return (
            
                <>

                <div className="ps-home ps-home--1">
                    
                    {/* <MainSlider  mainslider={this.state.mainslider}/> */}

                    <div className="ps-home__content">
                        

                        {this.state.home.map((homeItems)=>{
                            
                                    

                                    if(homeItems.baseic_details.upload_type==='B'){

                                        if(homeItems.baseic_details.page_master_id==='2'){ /* Static Banner - 1 */
                                            return(
                                                <HomeStaticBanner1  banner={homeItems.component_items[0]}/>
                                            )
                                        }else if(homeItems.baseic_details.page_master_id==='3'){ /* Static Banner - 2 */
                                            return(
                                                <HomeStaticBanner2  banner={homeItems.component_items}/>
                                            )
                                        }else if(homeItems.baseic_details.page_master_id==='4'){ /* Static Banner - 3 */
                                            return(
                                                <HomeStaticBanner3  banner={homeItems.component_items}/>
                                            )
                                        }else if(homeItems.baseic_details.page_master_id==='5'){ /* Static Banner - 4 */
                                            return(
                                                <HomeStaticBanner4  banner={homeItems.component_items}/>
                                            )
                                        }else if(homeItems.baseic_details.page_master_id==='6'){ /* Static Banner - 3 (Type 1) */

                                        }else if(homeItems.baseic_details.page_master_id==='7'){ /* Static Banner - 3 (Type 2) */

                                        }else if(homeItems.baseic_details.page_master_id==='8'){ /* Static Banner - 3 (Type 3) */
                                        
                                        }else if(homeItems.baseic_details.page_master_id==='9'){ /* Static Banner - 3 (Type 4) */

                                        }else if(homeItems.baseic_details.page_master_id==='10'){ /* Static Banner - 8 */
                                            return(
                                                <HomeStaticBanner8sub  banner={homeItems.component_items}/>
                                            )
                                        }else if(homeItems.baseic_details.page_master_id==='12'){ /* Static Banner - 8 */
                                            return(
                                                <HomeStaticBanner8  banner={homeItems.component_items}/>
                                            )
                                        }else if(homeItems.baseic_details.page_master_id==='13'){ /* Static Banner - 8 */
                                            return(
                                                <Testimonial  banner={homeItems.component_items}/>
                                            )
                                        }

                                    }else if(homeItems.baseic_details.upload_type==='P'){
                                        return(
                                            <ProductSlider  products={homeItems.component_items} title={homeItems.component_title}/>
                                        )
                                    }
                                }
                            )
                        }


                    </div>
                </div>

            </>
        );
    }
}

export default Home;
